package fr.manyverse.app.presentation.components.inventory

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import coil3.compose.SubcomposeAsyncImage
import coil3.compose.SubcomposeAsyncImageContent
import fr.manyverse.app.domain.model.ItemCategory

@Composable
fun InventoryItemImage(
    signedImageUrl: String?,
    itemName: String,
    category: ItemCategory,
    onClick: (() -> Unit)? = null,
    modifier: Modifier = Modifier,
    localImageBytes: ByteArray? = null,
    shape: Shape = RoundedCornerShape(topStart = 12.dp, topEnd = 12.dp)
) {
    // Aperçu d'une image locale non encore uploadée (ByteArray) prioritaire sur l'URL signée.
    val model: Any? = localImageBytes ?: signedImageUrl
    if (model != null) {
        SubcomposeAsyncImage(
            model = model,
            contentDescription = itemName,
            contentScale = ContentScale.Crop,
            modifier = modifier
                .clip(shape)
                .then(if (onClick != null) Modifier.clickable(onClick = onClick) else Modifier)
        ) {
            SubcomposeAsyncImageContent()
        }
    } else {
        Box(
            modifier = modifier
                .clip(shape)
                .background(MaterialTheme.colorScheme.surfaceVariant),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                painter = category.icon(),
                contentDescription = null,
                tint = MaterialTheme.colorScheme.onSurfaceVariant,
                modifier = Modifier.size(32.dp)
            )
        }
    }
}
